import { apiClient } from "./client";
import { Did, PaginatedResponse } from "@/types";

export interface Material {
  id: Did;
  code: string;
  name: string;
  description: string;
  price_cents: number;
  price_in_euros: number;
  created_at: string;
  updated_at: string;
}

export interface MaterialTimesheetPivot {
  quantity: number;
  line_price_cents: number;
}

/**
 * Get a single material with details
 */
export const getMaterial = async (id: Did): Promise<Material> => {
  const { data } = await apiClient.get<Material>(`/materials/${id}`);
  return data;
};

export interface MaterialSearchParams {
  search?: string;
  page?: number;
}

/**
 * Get paginated materials with search
 */
export const getMaterialsPaginated = async (
  params: MaterialSearchParams = {}
): Promise<PaginatedResponse<Material>> => {
  const { data } = await apiClient.get<PaginatedResponse<Material>>(
    "/materials",
    {
      params,
    }
  );
  return data;
};
